import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { cn } from './cn.js';
const sizeClass = {
    sm: 'size-6 text-micro tracking-normal',
    md: 'size-8 text-caption',
    lg: 'size-10 text-ui',
};
/** "Ana Horvat" → "AH"; a single word gives its first two letters. */
export function initials(name) {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0)
        return '';
    if (parts.length === 1)
        return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
const AvatarRoot = React.forwardRef(({ className, size = 'md', ...props }, ref) => (_jsx(AvatarPrimitive.Root, { ref: ref, "data-slot": "avatar", className: cn('relative flex shrink-0 overflow-hidden rounded-full', sizeClass[size], className), ...props })));
AvatarRoot.displayName = AvatarPrimitive.Root.displayName;
const AvatarImage = React.forwardRef(({ className, ...props }, ref) => (_jsx(AvatarPrimitive.Image, { ref: ref, className: cn('aspect-square size-full', className), ...props })));
AvatarImage.displayName = AvatarPrimitive.Image.displayName;
const AvatarFallback = React.forwardRef(({ className, ...props }, ref) => (_jsx(AvatarPrimitive.Fallback, { ref: ref, className: cn('flex size-full items-center justify-center rounded-full bg-muted font-display font-semibold text-foreground', className), ...props })));
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;
/** Initials on `muted`: the signed-in user in the top bar, an actor in an activity row. */
export function Avatar({ name, src, size = 'md', className }) {
    return (_jsxs(AvatarRoot, { size: size, className: className, "aria-label": name, role: "img", children: [src && _jsx(AvatarImage, { src: src, alt: "" }), _jsx(AvatarFallback, { delayMs: src ? 300 : undefined, children: initials(name) })] }));
}
export { AvatarRoot, AvatarImage, AvatarFallback };
//# sourceMappingURL=avatar.js.map